'use client';
export { default } from './components/cookies';
